import styled, { css } from 'styled-components';
import tw from 'twin.macro';

/* The chips of the active filters stay on one line and scroll sideways, so the
 * toolbar band keeps its height however many there are. What scrolls out of
 * sight is faded rather than cut off at the frame's edge: the fade is the only
 * sign that there is more, and it appears on a side exactly while there is
 * something on it (see useScrollOverflow). */

/* 1.5rem of fade, and a mask that is opaque everywhere else */
const fadeMask = ($before: boolean, $after: boolean) => {
  if (!$before && !$after) return null;
  const stops = [
    $before ? 'transparent 0, black 1.5rem' : 'black 0',
    $after ? 'black calc(100% - 1.5rem), transparent 100%' : 'black 100%'
  ].join(', ');
  return css`
    -webkit-mask-image: linear-gradient(to right, ${stops});
    mask-image: linear-gradient(to right, ${stops});
  `;
};

export const ChipsScroller = styled.div<{ $fadeBefore: boolean; $fadeAfter: boolean }>(
  ({ $fadeBefore, $fadeAfter }) => [
    tw`flex items-center flex-nowrap min-w-0 overflow-x-auto`,
    /* The row is as high as its chips: a scrollbar of its own would either add
       height to a fixed-height band or eat into the chips */
    css`
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    `,
    fadeMask($fadeBefore, $fadeAfter)
  ]
);
